import Footer from "../../footer"
import NavBar from "../../nav"

const InternationalTraining = () => {
  return <div className='international-training'>
    <NavBar />
    <div>
      <section className="clean-block pfa-content clearfix">
        <div className="divider sections">
          <h1>International Training</h1>
          <div className="headline-divider sections"></div>
          <h2>Latest Guidance. Best Operating Practices.</h2>
          <h3>Our International Training Process.</h3>
        </div>
      </section>
      <section className="clean-block show-checklists clearfix">
			<div className="container content-container process-container">	
				<div className="container-fluid">
					<div className="row">
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">Initial Training (24 hrs.)</div>
							</div>
							<div className="details">An introductory overview of FAA and ICAO Annex 6 for Oceanic Operations.</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">Recurrent Training (8 hrs.)</div>
							</div>
							<div className="details">A thorough review of the latest guidance for Oceanic Procedures.</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">Areas of Emphasis</div>
							</div>
							<div className="details">
								<ul>
									<li>Flight Release</li>
									<li>Computer Flight Plan</li>
									<li>Programming LRNS</li>
									<li>Contingency Procedures</li>
									<li>Postflight requirements</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default InternationalTraining